//src/components/UI/Button.jsx

import React from "react";


export default function Button({
  children,
  onClick,
  type = "button",
  variant = "primary",
  className = "",
  disabled = false,
}) {
  const base =
    "relative inline-flex items-center justify-center px-4 py-2 rounded-full font-medium transition-all duration-200 select-none";

  const variants = {
    primary:
      "bg-black text-white hover:bg-gray-900 hover:shadow-lg active:scale-95",

    secondary:
      "bg-white text-black border border-gray-200 hover:bg-gray-50 hover:shadow-md active:scale-95",

    danger:
      "bg-red-500 text-white hover:bg-red-600 hover:shadow-md active:scale-95",

    ghost:
      "bg-transparent text-black hover:bg-gray-100 active:scale-95",

    edit:
      "bg-white text-black border border-gray-200 hover:bg-gray-50 hover:shadow-md active:scale-95",
  };

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`${base} ${variants[variant]} ${className} ${
        disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"
      }`}
    >
      {children}
    </button>
  );
}
